import React from "react";

const DeleteIcon = ({ width, height, color }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66797 0.96582H9.34204V1.41577H10.3077V0.902832C10.3079 0.405029 9.90308 0 9.40552 0H6.60449C6.10693 0 5.70215 0.405029 5.70215 0.902832V1.41577H6.66797V0.96582Z"
        fill="#333333"
      />
      <path
        d="M12.5378 5.2417H3.47187C3.22346 5.2417 3.0279 5.45361 3.04792 5.70129L3.80585 15.0734C3.84809 15.5966 4.28449 15.9995 4.80878 15.9995H11.2008C11.725 15.9995 12.1614 15.5966 12.2037 15.0732L12.9616 5.70129C12.9818 5.45361 12.7862 5.2417 12.5378 5.2417ZM5.66706 14.9999C5.65693 15.0005 5.6468 15.0009 5.63679 15.0009C5.38361 15.0009 5.17109 14.8037 5.15534 14.5476L4.68037 6.85364C4.66401 6.5874 4.86652 6.35828 5.13264 6.34192C5.3979 6.32581 5.628 6.52783 5.64436 6.79419L6.11921 14.4882C6.13569 14.7544 5.93317 14.9834 5.66706 14.9999ZM8.49311 14.5179C8.49311 14.7845 8.27692 15.0007 8.0102 15.0007C7.74348 15.0007 7.52729 14.7845 7.52729 14.5179V6.82385C7.52729 6.55713 7.74348 6.34094 8.0102 6.34094C8.2768 6.34094 8.49311 6.55713 8.49311 6.82385V14.5179ZM11.3293 6.85229L10.8758 14.5463C10.8608 14.8029 10.6479 15.0007 10.3942 15.0007C10.3847 15.0007 10.3751 15.0005 10.3654 15C10.0992 14.9843 9.89606 14.7557 9.91181 14.4895L10.3652 6.79541C10.3808 6.52917 10.6086 6.32605 10.8756 6.3418C11.1418 6.35742 11.3449 6.58606 11.3293 6.85229Z"
        fill="#333333"
      />
      <path
        d="M14.2077 3.75073L13.8906 2.80005C13.807 2.54944 13.5724 2.38037 13.3081 2.38037H2.70152C2.43736 2.38037 2.20262 2.54944 2.11912 2.80005L1.80199 3.75073C1.74083 3.93408 1.82042 4.12109 1.96898 4.21436C2.02952 4.25232 2.10118 4.27515 2.17992 4.27515H13.8298C13.9086 4.27515 13.9803 4.25232 14.0408 4.21423C14.1893 4.12097 14.2689 3.93396 14.2077 3.75073Z"
        fill="#333333"
      />
    </svg>
  );
};

export default DeleteIcon;
